import { ImageProps, getImageProps } from 'next/image';
import { forwardRef } from 'react';
import { OrientationImageShape } from '@/shared/lib/types';

type Props = React.HTMLAttributes<HTMLPictureElement> & {
    sources: OrientationImageShape;
    alt?: ImageProps['alt'];
    sizes?: ImageProps['sizes'];
};

const OrientationImage = forwardRef<HTMLDivElement, Props>(({ sources, sizes = '100vw', alt = '', ...props }, ref) => {
    const _alt = sources.horizontal?.alt || sources.vertical?.alt || alt;
    const title = sources.horizontal?.title || sources.vertical?.title;

    const verticalImgProps = sources.vertical
        ? getImageProps({
              sizes,
              src: sources.vertical.src,
              width: sources.vertical.width || 1,
              height: sources.vertical.height || 1,
              alt: _alt,
          })
        : null;

    const {
        props: { srcSet, ...rest },
    } = getImageProps({
        sizes,
        src: sources.horizontal?.src || '',
        width: sources.horizontal?.width || 1,
        height: sources.horizontal?.height || 1,
        alt: _alt,
    });

    return (
        <picture {...props} ref={ref}>
            {verticalImgProps && <source media="(orientation: portrait)" srcSet={verticalImgProps.props.srcSet} />}
            {srcSet && <source srcSet={srcSet} />}
            <img {...rest} alt={_alt} title={title} />
        </picture>
    );
});

OrientationImage.displayName = 'OrientationImage';

export default OrientationImage;
